import { useState } from 'react';
import { useSelector } from 'react-redux';
import { values } from 'lodash';
import { Flex, Input, Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { momentTimezone } from '../utils/dateUtils';
import { allIcons, NormalIcon } from '../utils/Icon';
import { TState, useActions } from '../../redux/store';

const RdvTable = ({ data }: any) => {
  const currentTab = useSelector((state: TState) => state.currentTab);
  const planningTab = useSelector((state: TState) => state.planningTab);

  const [filter, setFilter] = useState('');

  const {
    setCurrentTab,
    setCalendarCurrentDay,
    onClose,
    setRowData,
    setModalType,
  } = useActions();

  const filteredData = data.filter((rd: any) =>
    values(rd)
      .map((v) => JSON.stringify(v))
      .join(' ')
      .toLowerCase()
      .includes(filter.toLowerCase()),
  );

  const goToRdv = (appoint: any) => {
    setCalendarCurrentDay(momentTimezone(appoint.planningDate).toISOString());

    if (currentTab?.isPlanning) {
      onClose();
    } else {
      setCurrentTab(planningTab);
    }
  };

  const editRdv = (appoint: any) => {
    setRowData(appoint);
    setModalType('updatePlanning');
  };

  return (
    <>
      <Input
        placeholder='Rechercher un champ'
        mb={2}
        onChange={(e) => setFilter(e.target.value)}
        value={filter}
      />
      <Table size='sm'>
        <Thead>
          <Tr>
            <Th>Date/Heure</Th>
            <Th>Assigné à</Th>
            <Th>Par</Th>
            <Th>Type</Th>
            <Th w='120px' whiteSpace='nowrap'>
              Voir / Modifier
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {filteredData.reverse().map((d: any) => (
            <Tr>
              <Td>
                {momentTimezone(d.planningDate).format('DD/MM/YYYY HH:mm')}
              </Td>
              <Td>{d.user?.name || d.user?.login}</Td>
              <Td>{d.createdBy?.name || d.createdBy?.login || '-'}</Td>
              <Td>{d.planningTypeName}</Td>
              <Td>
                <Flex justifyContent='center' gap={1}>
                  <NormalIcon as={allIcons.HiEye} onClick={() => goToRdv(d)} />
                  <NormalIcon
                    as={allIcons.HiPencilSquare}
                    onClick={() => editRdv(d)}
                  />
                </Flex>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </>
  );
};

export default RdvTable;
